import { render } from "./UnAuthorized.vue?vue&type=template&id=a0f7f046"
import script from "./UnAuthorized.vue?vue&type=script&lang=js"
export * from "./UnAuthorized.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__